export interface INavigationRoute {
  name: string
  displayName: string
  meta: { icon: string }
  children?: INavigationRoute[]
}

export default {
  root: {
    name: '/',
    displayName: 'navigationRoutes.home',
  },
  routes: [
    {
      name: 'dashboard',
      displayName: 'menu.dashboard',
      meta: {
        icon: 'speed',
      },
    },
    // {
    //   name: 'purchase_history',
    //   displayName: 'menu.purchase_history',
    //   meta: {
    //     icon: 'analytics',
    //   },
    // },
    // {
    //   name: 'steal_stat',
    //   displayName: 'menu.steal_stat',
    //   meta: {
    //     icon: 'analytics',
    //   },
    // },

    // Order Management
    {
      name: 'orders',
      displayName: 'menu.orders',
      meta: {
        icon: 'receipt_long',
      },
    },

    // Exchange Page
    {
      name: 'exchange',
      displayName: 'menu.exchange',
      meta: {
        icon: 'currency_exchange',
      },
      children: [
        // {
        //   name: 'exchange-plans',
        //   displayName: 'menu.exchange-plans',
        //   meta: {
        //     icon: 'price_change',
        //   },
        // },
        {
          name: 'payment-platforms',
          displayName: 'menu.payment-platforms',
          meta: {
            icon: 'credit_card',
          },
        },
        {
          name: 'payment-channels',
          displayName: 'menu.payment-channels',
          meta: {
            icon: 'payment',
          },
        },
      ],
    },
    //Agent Tab
    {
      name: 'users_tab',
      displayName: 'menu.users_tab',
      meta: {
        icon: 'person',
      },
    },

    // Agents Management
    {
      name: 'Agents-section',
      displayName: 'menu.agents',
      meta: {
        icon: 'groups',
      },
      children: [
        // {
        //   name: 'users',
        //   displayName: 'menu.admins',
        //   meta: {
        //     icon: 'account_circle',
        //   },
        // },
        {
          name: 'agents-management',
          displayName: 'menu.agents-list',
          meta: {
            icon: 'people',
          },
        },
        // {
        //   name: 'agents-revenue',
        //   displayName: 'menu.agents-revenue',
        //   meta: {
        //     icon: 'paid',
        //   },
        // },
        // // {
        // //   name: 'price-config',
        // //   displayName: 'menu.price',
        // //   meta: {
        // //     icon: 'price_change',
        // //   },
        // },
        {
          name: 'agent-agents-incomes',
          displayName: 'menu.agent-incomes',
          meta: {
            icon: 'payments',
          },
        },
      ],
    },
// Ads
{
  name: 'ads',
  displayName: 'menu.ads',
  meta: { icon: 'ads_click' },
  children: [
    {
      name: 'ads',
      displayName: 'menu.ads',
      meta: { icon: 'campaign' },
    },
    {
      name: 'video-ads',
      displayName: 'ads.tabs.video_ads',
      meta: { icon: 'videocam' },
    },
    {
      name: 'video-durations',
      displayName: 'ads.tabs.video_durations',
      meta: { icon: 'timer' },
    },
    {
      name: 'activities',
      displayName: 'ads.tabs.activities',
      meta: { icon: 'event' },
    },
    {
      name: 'collections',
      displayName: 'ads.tabs.collections',
      meta: { icon: 'groups' },
    },
    {
      name: 'placements',
      displayName: 'ads.tabs.placements',
      meta: { icon: 'place' },
    },
    {
      name: 'switches',
      displayName: 'ads.tabs.switches',
      meta: { icon: 'toggle_on' },
    },
    {
      name: 'triggers',
      displayName: 'ads.tabs.triggers',
      meta: { icon: 'psychology' },
    },
    {
      name: 'ads-settings',
      displayName: 'ads.tabs.settings',
      meta: { icon: 'settings' },
    },
    {
      name: 'tracking',
      displayName: 'ads.tabs.tracking',
      meta: { icon: 'analytics' },
    },
    {
      name: 'statistics',
      displayName: 'ads.tabs.statistics',
      meta: { icon: 'bar_chart' },
    },
    {
      name: 'targeting',
      displayName: 'ads.tabs.targeting',
      meta: { icon: 'gps_fixed' },
    },
    {
      name: 'ads-agents',
      displayName: 'ads.tabs.agents',
      meta: { icon: 'business' },
    },
  ],
},
    // Emoji etc
    {
      name: 'media',
      displayName: 'menu.media',
      meta: {
        icon: 'brush',
      },
      children: [
        {
          name: 'promotions',
          displayName: 'menu.promotions',
          meta: {
            icon: 'campaign',
          },
        },
        {
          name: 'annonce-editor',
          displayName: 'menu.annonce_editor',
          meta: {
            icon: 'edit_notifications',
          },
        },
         {
          name: 'annonce-editor_dark',
          displayName: 'menu.annonce_editor_dark',
          meta: {
            icon: 'edit_notifications',
          },
        },
        {
          name: 'banner',
          displayName: 'menu.banner',
          meta: {
            icon: 'flag',
          },
        },
      
        // {
        //   name: 'promotion-platform',
        //   displayName: 'menu.promotion-platform',
        //   meta: {
        //     icon: 'share',
        //   },
        // },
        {
          name: 'promotion-link',
          displayName: 'menu.promotion-link',
          meta: {
            icon: 'label',
          },
        },
        {
          name: 'promotion-tracking',
          displayName: 'menu.promotion-tracking',
          meta: {
            icon: 'hub',
          },
        },
      ],
    },
    // VIP Management
    {
      name: 'vip-section',
      displayName: 'menu.vip',
      meta: {
        icon: 'workspace_premium',
      },
      children: [
        {
          name: 'movie_price',
          displayName: 'menu.movie-price',
          meta: {
            icon: 'movie',
          },
        },
        {
          name: 'vip',
          displayName: 'menu.vip-plans',
          meta: {
            icon: 'star',
          },
        },

        {
          name: 'vip-setting',
          displayName: 'menu.vip-setting',
          meta: {
            icon: 'settings',
          },
        },
        {
          name: 'vip-rights',
          displayName: 'menu.vip-rights',
          meta: {
            icon: 'verified_user',
          },
        },
        {
          name: 'agents-vip',
          displayName: 'menu.agents-vip',
          meta: {
            icon: 'people',
          },
        },
        {
          name: 'users-vip',
          displayName: 'menu.users-vip',
          meta: {
            icon: 'people',
          },
        },
      ],
    },

    {
      name: 'announcements',
      displayName: 'menu.system_announcements',
      meta: {
        icon: 'ads_click',
      },
    },

    // ========== MODIFICATION : Menu Withdraw regroupé ==========
    // Dans navigation.ts - Structure plate sans children
{
  name: 'withdraw-section',
  displayName: 'menu.withdraw',
  meta: {
    icon: 'account_balance_wallet',
  },
  children: [
    {
      name: 'withdraw',  // Correspond au nom de la route existante
      displayName: 'menu.withdrawManagement',
      meta: {
        icon: 'arrow_downward',
      },
    },
    {
      name: 'admin-agent-withdraw',  
      displayName: 'menu.withdrawAgent',
      meta: {
        icon: 'arrow_downward',
      },
    },
  ],
},

    // Content Management
    {
      name: 'content-section',
      displayName: 'menu.content',
      meta: {
        icon: 'perm_media',
      },
      children: [
        // Chat
        {
          name: 'chat-section',
          displayName: 'menu.chat',
          meta: {
            icon: 'chat_bubble',
          },
          children: [
            {
              name: 'chat-conversations',
              displayName: 'menu.chat_conversations',
              meta: { icon: 'comment' },
            },
            {
              name: 'chat-log',
              displayName: 'menu.chat_log',
              meta: { icon: 'history' },
            },
            {
              name: 'emoji',
              displayName: 'menu.all-emoji',
              meta: {
                icon: 'sentiment_satisfied',
              },
            },
            {
              name: 'user-notification',
              displayName: 'menu.user-notification',
              meta: {
                icon: 'notifications',
              },
            },
          ],
        },
        {
          name: 'videos',
          displayName: 'menu.videos',
          meta: {
            icon: 'movie',
          },
          children: [
            {
              name: 'videos',
              displayName: 'menu.all-videos',
              meta: {
                icon: 'play_circle',
              },
            },
            {
              name: 'category',
              displayName: 'menu.category',
              meta: {
                icon: 'laptop',
              },
            },
            {
              name: 'tag',
              displayName: 'menu.tag',
              meta: {
                icon: 'label',
              },
            },
          ],
        },

        {
          name: 'posts',
          displayName: 'menu.post',
          meta: {
            icon: 'layers',
          },
          children: [
            {
              name: 'post',
              displayName: 'menu.all-post',
              meta: {
                icon: 'upload',
              },
            },
            {
              name: 'category_p',
              displayName: 'menu.category_p',
              meta: {
                icon: 'archive',
              },
            },
            {
              name: 'tag_p',
              displayName: 'menu.tag_p',
              meta: {
                icon: 'bookmark',
              },
            },
            // new menu
            {
              name: 'coming_soon',
              displayName: 'menu.coming_soon',
              meta: {
                icon: 'upload',
              },
            },
          ],
        },

        {
          name: 'mangas',
          displayName: 'menu.mangas',
          meta: {
            icon: 'book',
          },
        },
      ],
    },
    {
      name: 'domain_name_registration',
      displayName: 'menu.domain_name_registration',
      meta: {
        icon: 'cloud',
      },
    },
    {
      name: 'system-settings',
      displayName: 'menu.system-settings',
      meta: {
        icon: 'tune',
      },
    },
    {
      name: 'domain',
      displayName: 'menu.domain',
      meta: {
        icon: 'dns',
      },
      children: [
        {
          name: 'domain-management',
          displayName: 'menu.domain_management',
          meta: {
            icon: '',
          },
        },
        
        {
          name: 'domain-surveillance',
          displayName: 'menu.domain_surveillance',
          meta: {
            icon: '',
          },
        },
        {
          name: 'domain-mapping',
          displayName: 'menu.domain_mapping',
          meta: {
            icon: '',
          },
        },
        {
          name: 'domain-failover',
          displayName: 'menu.domain_failover',
          meta: {
            icon: '',
          },
        },
        {
          name: 'domain-api-change-logs',
          displayName: 'menu.domain_api_change_logs',
          meta: {
            icon: '',
          },
        },
        {
          name: 'domain-resource-change-logs',
          displayName: 'menu.domain_resource_change_logs',
          meta: {
            icon: '',
          },
        },
      ],
    },
    // Wallet Management
    {
      name: 'wallet-management',
      displayName: 'menu.wallet_management',
      meta: {
        icon: 'account_balance_wallet',
      },
    },
    {
      name: 'landing',
      displayName: 'menu.landing',
      meta: { icon: 'language' },
      children: [
        { name: 'landing-page', displayName: 'menu.landing-page', meta: { icon: 'web' } },
        { name: 'landing-management', displayName: 'menu.landing-management', meta: { icon: 'settings' } },
      ],
    },

    // Versions Management
    {
      name: 'versions-section',
      displayName: 'menu.versions',
      meta: {
        icon: 'phone_iphone',
      },
      children: [
        {
          name: 'versions',
          displayName: 'menu.versions',
          meta: {
            icon: 'system_update',
          },
        },
        {
          name: 'versions-link',
          displayName: 'menu.versions-link',
          meta: {
            icon: 'link',
          },
        },
      ],
    },
    {
      name: 'country',
      displayName: 'menu.country',
      meta: {
        icon: 'public',
      },
    },

    {
      name: 'config',
      displayName: 'menu.config',
      meta: {
        icon: 'settings',
      },
    },
    {
      name: 'translate',
      displayName: 'menu.gestion_traduction',
      meta: {
        icon: 'translate',
      },
    },
  ] as INavigationRoute[],
}